"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// CORE
const react_1 = __importStar(require("react"));
const am4core = __importStar(require("@amcharts/amcharts4/core"));
const am4charts = __importStar(require("@amcharts/amcharts4/charts"));
const styles_1 = require("@mui/material/styles");
const RendersCount_1 = __importDefault(require("components/RendersCount"));
const useXYChart_1 = __importDefault(require("hooks/useXYChart"));
const AreaChart = (0, react_1.forwardRef)(({ data, height, orderedFields, stacked, withBullets, overrideColors, withLegend, curvy }, ref) => {
    const { chart, xAxis, yAxis, buildTooltipOn, buildTooltipSeriesInfo, buildLegend } = (0, useXYChart_1.default)('area-chart-div');
    const { palette, shape, components } = (0, styles_1.useTheme)();
    const colors = (0, react_1.useMemo)(() => overrideColors || palette.data.sequence1.map((color) => am4core.color(color)), [palette, overrideColors]);
    const createSeries = (0, react_1.useCallback)((field, name, fill, withTooltip) => {
        const series = chart.series.push(new am4charts.LineSeries());
        series.name = name;
        series.dataFields.valueY = field;
        series.dataFields.categoryX = 'category';
        series.tooltip.getFillFromObject = false;
        series.fillOpacity = 0.6;
        series.fill = fill;
        series.strokeWidth = 2;
        series.stroke = fill;
        if (curvy) {
            series.tensionX = 0.85;
        }
        series.stacked = stacked || false;
        if (withBullets) {
            const bullet = series.bullets.push(new am4charts.CircleBullet());
            bullet.circle.radius = 4;
            bullet.circle.fill = am4core.color(palette.color6.opacity100);
            bullet.circle.strokeWidth = 1;
            bullet.circle.stroke = am4core.color(palette.greyScaleDeprecated[7]);
            const hoverState = bullet.states.create('hover');
            hoverState.properties.scale = 1.5;
        }
        if (withTooltip) {
            chart.cursor.snapToSeries = series;
            buildTooltipOn(series);
            let listOfSeriesHTML = '';
            chart.series.each((item) => {
                listOfSeriesHTML += buildTooltipSeriesInfo(item);
            });
            series.tooltipHTML = `<div style="color: ${palette.text.secondary};border-radius: ${shape.borderRadius * 2}px;padding: ${shape.padding[2]}px;" >
        ${listOfSeriesHTML}
        <div style="width: 100%:height: 2px;border-bottom-width: 1px;border-bottom-style: solid;border-bottom-color: ${palette.grey.level3};margin: 5px 0px;"></div>
        <div style="color: inherit;background-color: inherit;font-size: 12px;" id="tooltip_date" >{category}</div>
        <div style="color: ${components.tooltip.primaryTextColor};font-size: 14px;background-color: inherit;display: flex;align-items: center;justify-content: space-between" >
            <span>Total Balance</span>&nbsp;
            <span id="tooltip_total_amount" >\${valueY.total}</span>
        </div>
      </div>`;
        }
        return series;
    }, [chart, stacked, withBullets, palette, shape, components, buildTooltipOn, buildTooltipSeriesInfo, curvy]);
    (0, react_1.useLayoutEffect)(() => {
        var _a, _b, _c;
        if (chart && !chart.isDisposed() && orderedFields) { // this is where to set up chart specific stuff
            yAxis.renderer.grid.template.disabled = false;
            yAxis.renderer.ticks.template.disabled = false;
            yAxis.renderer.grid.template.stroke = palette.grey.level2;
            xAxis.startLocation = 0.4;
            xAxis.endLocation = 0.6;
            chart.cursor = new am4charts.XYCursor();
            chart.cursor.lineY.disabled = true;
            chart.cursor.behavior = 'none';
            chart.cursor.lineX.disabled = false;
            chart.cursor.lineX.strokeDasharray = '';
            chart.cursor.lineX.strokeWidth = 1;
            chart.cursor.lineX.stroke = am4core.color(palette.greyScaleDeprecated[0]);
            chart.numberFormatter.numberFormat = '#,###.00';
            (_a = chart === null || chart === void 0 ? void 0 : chart.series) === null || _a === void 0 ? void 0 : _a.clear();
            chart.invalidateData();
            orderedFields === null || orderedFields === void 0 ? void 0 : orderedFields.forEach((field, i) => createSeries(field, field, colors[i], i === orderedFields.length - 1));
            chart.data = data;
            if (withLegend) {
                buildLegend();
            }
            else {
                (_c = (_b = chart.legend) === null || _b === void 0 ? void 0 : _b.dispose) === null || _c === void 0 ? void 0 : _c.call(_b); // clean up old legend if it exists
            }
        }
    }, [chart, orderedFields, yAxis, createSeries, colors, palette.grey.level2, data, buildLegend, xAxis, palette.greyScaleDeprecated, withLegend]);
    (0, react_1.useImperativeHandle)(ref, () => ({
        getGraphImage() {
            var _a;
            return (_a = chart === null || chart === void 0 ? void 0 : chart.exporting) === null || _a === void 0 ? void 0 : _a.getImage('png', { quality: 1, scale: 3 });
        },
    }));
    const divStyle = (0, react_1.useMemo)(() => ({ width: '100%', height: height || 400 }), [height]);
    return (<>
      <RendersCount_1.default id="newReportsAreaChart"/>
      <div id="area-chart-div" style={divStyle}/>
    </>);
});
exports.default = AreaChart;
